export default {
  hero: {
    badge: "Nuestra Historia",
    titlePrefix: "Sobre ",
    titleHighlight: "Nosotros",
    subtitle: "Conoce la historia detrás de Smart Business Digital Solutions y la misión que nos impulsa a empoderar emprendedores latinos en todo el mundo."
  },
  story: {
    photoBadge: "Fundadora & CEO",
    badge: "Mi Historia",
    title: "De Emprendedora a",
    titleHighlight: "Mentora Digital",
    p1: "Cathy Roldán es una emprendedora, mentora digital y educadora apasionada por empoderar a la comunidad latina. Con raíces profundas en la cultura hispana, Cathy entendió desde temprano que el acceso a la educación digital podía cambiar vidas.",
    p2: "Comenzó su camino en el marketing digital de forma autodidacta, aprendiendo cada herramienta, cada estrategia y cada plataforma disponible. Lo que empezó como una necesidad personal se convirtió en una misión: democratizar el conocimiento digital para emprendedores latinos.",
    p3: "Hoy, a través de Smart Business Digital Solutions LLC y Smart Business Academy, Cathy ha ayudado a más de 500 estudiantes y 200 clientes a transformar sus negocios, aumentar sus ingresos y construir marcas poderosas en el mundo digital.",
    p4: "Su enfoque combina estrategia de marketing digital, herramientas de inteligencia artificial, automatización de negocios y educación práctica. Todo diseñado para que cualquier emprendedor, sin importar su nivel técnico, pueda dominar el mundo online.",
    trajectoryTitle: "Trayectoria",
    milestones: {
       m1: { year: "2018", title: "El Comienzo", desc: "Cathy inicia su carrera en marketing digital, aprendiendo de forma autodidacta las estrategias de redes sociales y negocios online." },
       m2: { year: "2019", title: "Primeros Clientes", desc: "Comienza a trabajar con pequeños negocios latinos, ayudándoles a establecer su presencia digital y aumentar sus ventas." },
       m3: { year: "2021", title: "Smart Business Nace", desc: "Funda Smart Business Digital Solutions LLC, consolidando su equipo y expandiendo los servicios de marketing digital y automatización." },
       m4: { year: "2022", title: "Smart Business Academy", desc: "Lanza la academia online para emprendedores latinos, democratizando el acceso a educación digital de calidad." },
       m5: { year: "2024", title: "Impacto Global", desc: "Más de 500 estudiantes y 200 clientes en toda Latinoamérica y Estados Unidos, con presencia en múltiples plataformas digitales." }
    }
  },
  missionVision: {
    mission: {
      label: "Misión",
      title: "Empoderar Emprendedores Latinos",
      text: "Nuestra misión es empoderar a emprendedores y dueños de negocios latinos en todo el mundo, brindándoles las herramientas, estrategias y conocimientos de marketing digital e inteligencia artificial necesarios para construir negocios rentables y sostenibles en la era digital."
    },
    vision: {
      label: "Visión",
      title: "Líderes del Mundo Digital Latino",
      text: "Ser la empresa de marketing digital y educación online más influyente para la comunidad latina, creando un ecosistema donde cada emprendedor hispano tenga acceso a las mismas oportunidades digitales que los líderes globales del negocio."
    },
    valuesTitle: "Nuestros Valores",
    valuesHighlight: "Define",
    valuesSub: "Lo Que Nos",
    items: {
      community: { title: "Comunidad", desc: "Creemos en el poder de la comunidad latina y trabajamos para fortalecer cada negocio que forma parte de ella." },
      innovation: { title: "Innovación", desc: "Adoptamos las últimas tecnologías de IA y marketing digital para mantener a nuestros clientes a la vanguardia." },
      integrity: { title: "Integridad", desc: "Trabajamos con transparencia y honestidad, priorizando siempre el éxito real de nuestros clientes." },
      results: { title: "Resultados", desc: "Nos enfocamos en métricas reales: más seguidores, más ventas, más ingresos para tu negocio." }
    },
    experienceTitle: "Experiencia & Especialidades",
    areas: {
      marketing: "Marketing Digital",
      tech: "Tecnología & IA",
      education: "Educación & Coaching"
    }
  }
};
